import { render, staticRenderFns } from "./project-link-settle.vue?vue&type=template&id=332b3b86"
import script from "./project-link-settle.vue?vue&type=script&lang=tsx"
export * from "./project-link-settle.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports